import { useQuery } from "@/compat/reactQuery";
import queryKeys from "../../../constants/queryKeys";
import riskAssessmentHistoryService from "../../services/riskAssessmentHistoryService";

const useRiskAssessmentHistoryAcknowledgementRecipients = (riskAssessmentHistoryId) =>
  useQuery(
    [
      queryKeys.riskAssessmentHistoryAcknowledgementRecipients,
      riskAssessmentHistoryId,
    ],
    () => riskAssessmentHistoryService.getRiskAssessmentHistoryAcknowledgementRecipients(riskAssessmentHistoryId),
    {
      enabled: !!riskAssessmentHistoryId,
      // A never-shared RA returns HTTP 400 by design; without this, react-query's
      // default 3-retry exponential backoff (1s+2s+4s) makes the panel spin ~7s
      // before showing the empty state. Don't retry — the 400 is an expected state.
      // (Matches useSitesByNameSearch / useAccountLinkableUserSearch.)
      retry: false,
    }
  );

export default useRiskAssessmentHistoryAcknowledgementRecipients;